import { render, staticRenderFns } from "./MyComment.vue?vue&type=template&id=5dede3ff&"
import script from "./MyComment.vue?vue&type=script&lang=js&"
export * from "./MyComment.vue?vue&type=script&lang=js&"
import style0 from "./MyComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports